export default "__VITE_ASSET__y09M$O_v__"